import { Component } from 'react';
import { connect } from 'react-redux';

import { addCouponOrGiftCard } from 'redux/cart/actions';

class CouponForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: '',
      errorMessage: ''
    };
  }

  handleChange = (e) => {
    this.setState({
      input: e.target.value,
      errorMessage: ''
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { props } = this;
    const { input } = this.state;

    const errorFunction = (error) => {
      let message = '';
      const err = error.data.message;
      switch (error.data.statusCode) {
        case 422:
          message = error.data.message;
          break;
        case 404:
          if (error.data.key === 'invalidCode') {
            message = 'Invalid coupon code';
          } else if (error.data.key === 'couponExpired') {
            message = 'Coupon expired';
          } else if (error.data.key === 'couponNotActive') {
            message = 'Coupon not active';
          } else {
            message = 'Invalid coupon code or gift code';
          }

          break;
        default:
          message = err;
          break;
      }
      this.setState({
        errorMessage: message
      });
    };
    props.addCouponOrGiftCard(input, undefined, errorFunction);

    this.setState({
      input: ''
    });
  };

  renderError = (message) => (
    <span className="c7-message--error" id="promocodeerror">
      Error: {message}
    </span>
  );

  render() {
    const { state, props } = this;
    let describedby;
    if (state.errorMessage) {
      describedby = { 'aria-describedby': 'promocodeerror' };
    }
    const formVisbleClass = props.isVisible
      ? 'c7-form c7-visible c7-coupon-form'
      : 'c7-form';
    return (
      <>
        <form
          className={formVisbleClass}
          onSubmit={this.handleSubmit}
          method="post"
        >
          <div className="c7-form__group">
            <input
              value={state.input}
              type="text"
              id="c7-promoCode"
              name="promocode"
              placeholder="Enter your coupon code or gift card"
              onChange={this.handleChange}
              aria-label="Coupon code"
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...describedby}
            />
            <button type="submit" className="c7-button">
              Apply
            </button>
          </div>
          {state.errorMessage && this.renderError(state.errorMessage)}
        </form>
      </>
    );
  }
}

export default connect(null, { addCouponOrGiftCard })(CouponForm);
